<div class="dialog-container">
  <div class="dialog-header">
    <mat-icon class="warning-icon">warning_amber</mat-icon>
    <h2 mat-dialog-title>{{ data.title }}</h2>
  </div>

  <mat-dialog-content class="dialog-content">
    <p class="dialog-message">{{ data.message }}</p>

    <div *ngIf="data.vesselName" class="record-details-card">
      <div class="detail-row">
        <span class="label">Vessel Name:</span>
        <span class="value">{{ data.vesselName }}</span>
      </div>
      <div class="detail-row">
        <span class="label">Port:</span>
        <span class="value">{{ data.portName }}</span>
      </div>
      <div class="detail-row">
        <span class="label">ETA (LT):</span>
        <span class="value">{{ data.eta | date:'medium' }}</span>
      </div>
    </div>

    <p class="prompt-question">Do you want to proceed?</p>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    <button 
      type="button" 
      class="btn btn-cancel" 
      (click)="onNo()">
      NO
    </button>
    <button 
      type="button" 
      class="btn btn-proceed" 
      (click)="onYes()">
      YES
    </button>
  </mat-dialog-actions>
</div>